import { render, staticRenderFns } from "./ReviewQueue.vue?vue&type=template&id=50fb40a7&scoped=true"
import script from "./ReviewQueue.vue?vue&type=script&lang=js"
export * from "./ReviewQueue.vue?vue&type=script&lang=js"
import style0 from "./ReviewQueue.vue?vue&type=style&index=0&id=50fb40a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fb40a7",
  null
  
)

export default component.exports